import { WTabs, type WTabItem } from "@/components/WTabs.tsx";
import { WButton } from "@/components/button/WButton.tsx";
import { useConfig } from "@/config.ts";
import { AppCatalog } from "@/modules/dashboard/AppCatalog.tsx";
import { CoreServices } from "@/modules/dashboard/CoreServices.tsx";
import { ManagedServices } from "@/modules/dashboard/ManagedServices.tsx";
import { hasNoResourcesAtom } from "@/modules/dashboard/recentQuery.ts";
import { Trans } from "@lingui/react/macro";
import { filterFalse } from "@warrenio/utils/collections/filterFalse";
import { useAtomValue } from "jotai/react";
import { useState } from "react";

export function StartSomethingNew() {
    //#region Hooks
    const { servicesEnabled, vmAppsEnabled } = useConfig();
    const hasNoResources = useAtomValue(hasNoResourcesAtom);
    const [selectedMore, setMore] = useState<boolean | undefined>(undefined);
    //#endregion

    // Only set "more" mode automatically once the resources have loaded (this means that they might be displayed in
    // compact mode for a moment).
    const more = selectedMore ?? hasNoResources;

    const tabs = filterFalse<WTabItem>([
        {
            id: "core",
            title: (
                <Trans comment="All the main resources and services offered by the cloud platform">Core services</Trans>
            ),
            content: <CoreServices more={more} />,
        },
        vmAppsEnabled && { id: "app", title: <Trans>App catalog</Trans>, content: <AppCatalog more={more} /> },
        servicesEnabled && {
            id: "managed",
            title: <Trans>Managed services</Trans>,
            content: <ManagedServices more={more} />,
        },
    ]);

    function toggleMore() {
        setMore(!more);
    }

    return (
        <div>
            <h2 className="font-size-title pl-4">
                <Trans>Start something new</Trans>
            </h2>

            <WTabs
                wideHeader
                button={
                    <WButton
                        action={() => toggleMore()}
                        color="primary"
                        icon={more ? "jp-icon-caretup" : "jp-icon-caretdown"}
                        iconSide="right"
                        variant="ghost"
                        size="bar"
                    >
                        {more ? <Trans>Less details</Trans> : <Trans>More details</Trans>}
                    </WButton>
                }
                items={tabs}
            />
        </div>
    );
}
